import { React, useState, useEffect } from "react";
import '../App.css';
import { useLocation } from "react-router-dom";
import '../../node_modules/firebase/compat/firestore';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import NavbarDefault from "./components/navbarDefault";
import FooterDefault from "./components/footerDefault";

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function TicketCreated() {
  const location = useLocation();
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={false} disableGutters>
        <Box>
          <NavbarDefault /> 
          <Box style={{ display:'flex', justifyContent:'center' }}>
            <Grid sx={{my:20}}>
              <Card sx={{boxShadow:5, mb:3}} style={{ maxWidth: 550, padding: "10px 50px", margin: "0 auto", justifyContent:'center' }}>
                <CardContent>
                  <Typography align = "center" fontWeight="bold" component="h1" variant="h5" sx={{ mt: 3 }} fontFamily="Segoe UI">
                    HELP REQUEST TICKET CREATED
                  </Typography>
                  <Typography component="h1" variant="body1" align="center" sx={{ mt: 3, mb: 1 }} fontFamily="Segoe UI">
                    Please take note of your ticket ID to be able to track your ticket's status in <a href= "/CheckTicket" style={{color: '#7B1113'}}>Check Ticket</a>.
                  </Typography>
                  <Typography fontWeight="bold" component="h1" variant="body1" align="center" sx={{ mt: 5, mb: 1 }} fontFamily="Segoe UI">
                    Your ticket ID is
                  </Typography>
                  <Typography align = "center" fontWeight="bold" component="h1" variant="h5" sx={{ mt: 1, mb: 2 }} fontFamily="Segoe UI" color="#223730">
                    {location.state.ticketID}
                  </Typography>
                  <Typography component="h1" variant="caption" align="center" sx={{ mt: 1, mb: 2 }} fontFamily="Segoe UI">
                      A copy of your ticket ID has also been sent to your email. Got more questions? <a href= "/OpenTicket" style={{color: '#7B1113'}}>Open another Ticket</a>.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Box>  
          <FooterDefault /> 
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default TicketCreated